import { Environment } from 'models/Environment';
import traIcon from 'assets/traIcon.svg';
import certIcon from 'assets/certIcon.svg';
import psiIcon from 'assets/psiIcon.svg';
import checkpointIcon from 'assets/checkpointIcon.svg';
import oneInspectIcon from 'assets/oneInspectIcon.svg';
import arbIcon from 'assets/arbIcon.svg';
import mmcIcon from 'assets/mmcIcon.svg';
import measureIcon from 'assets/measureIcon.svg';
import { RemoteAppDetails } from 'models/RemoteAppDetails';

const CERT_APP: RemoteAppDetails = {
  remoteUrl: '',
  moduleToLoad: './CERT',
  remoteName: 'CERTAssist',
  name: 'CERT',
  path: '/CERT',
  titleTextColor: '#EB9114',
  titleBarColor: '#FFFFFFFF',
  navIconColor: '#333333',
  iconId: 1,
  iconPath: certIcon,
  isEnabled: true,
  uamName: 'cert_assist'
};

const TRA_APP: RemoteAppDetails = {
  remoteUrl: '',
  moduleToLoad: './TRA',
  remoteName: 'TRAInspection',
  name: 'TRA',
  path: '/TRA',
  titleTextColor: '#8C1D58',
  titleBarColor: '#FFFFFFFF',
  navIconColor: '#333333',
  iconId: 2,
  iconPath: traIcon,
  isEnabled: true,
  uamName: 'tra_guided_inspect'
};

const PSI_APP: RemoteAppDetails = {
  remoteUrl: '',
  moduleToLoad: './PSI',
  remoteName: 'PSIInspection',
  name: 'PSI',
  path: '/PSI',
  titleTextColor: '#003468',
  titleBarColor: '#FFFFFFFF',
  navIconColor: '#333333',
  uamName: 'psi',
  iconId: 3,
  iconPath: psiIcon,
  isEnabled: true
};

const SPECIALITY_APP: RemoteAppDetails = {
  remoteUrl: '',
  moduleToLoad: './SPECIALITY',
  remoteName: 'SPECIALITYInspection',
  name: 'Specialty',
  path: '/Specialty',
  titleTextColor: '#C1DFF2',
  titleBarColor: '#FFFFFFFF',
  navIconColor: '#333333',
  iconId: 4,
  iconPath: checkpointIcon,
  isEnabled: false,
  banner: 'Request Access',
  uamName: ''
};

const ONE_INSPECT_APP: RemoteAppDetails = {
  remoteUrl: '',
  moduleToLoad: './SmartInspect',
  remoteName: 'SmartInspect',
  name: 'One Inspect',
  path: '/One Inspect',
  titleTextColor: '#2384EC',
  titleBarColor: '#FFFFFF',
  navIconColor: '#333333',
  iconId: 5,
  iconPath: oneInspectIcon,
  isEnabled: true,
  uamName: 'one_inspect'
};

const ARB_APP: RemoteAppDetails = {
  remoteUrl: '',
  moduleToLoad: './ARB',
  remoteName: 'ARBInspection',
  name: 'ARB',
  path: '/ARB',
  titleTextColor: '#753485',
  titleBarColor: '#FFFFFF',
  navIconColor: '#333333',
  iconId: 6,
  iconPath: arbIcon,
  isEnabled: true,
  uamName: 'arb'
};

const MMC_APP: RemoteAppDetails = {
  remoteUrl: '',
  moduleToLoad: './MMC',
  remoteName: 'MMCInspection',
  name: 'MMC',
  path: '/MMC',
  titleTextColor: '#008080',
  titleBarColor: '#FFFFFF',
  navIconColor: '#333333',
  iconId: 7,
  iconPath: mmcIcon,
  isEnabled: true,
  uamName: 'mmc'
};

const TRUE_MEASURE_APP: RemoteAppDetails = {
  remoteUrl: '',
  moduleToLoad: './CargoMeasurement',
  remoteName: 'CargoMeasurement',
  name: 'TrueMeasure',
  path: '/TrueMeasure',
  titleTextColor: '#005BA8',
  titleBarColor: '#FFFFFF',
  navIconColor: '#333333',
  iconId: 8,
  iconPath: measureIcon,
  isEnabled: true,
  uamName: 'cargo_measurement'
};

const REMOTE_APPLICATIONS: Record<Environment, RemoteAppDetails[]> = {
  local: [
    {
      ...CERT_APP,
      remoteUrl: 'http://localhost:3001/CERTAssistEntry.js'
    },
    {
      ...TRA_APP,
      remoteUrl: 'http://localhost:3002/TRAInspectionEntry.js'
    },
    {
      ...PSI_APP,
      remoteUrl: 'http://localhost:3003/PSIInspectionEntry.js'
    },
    {
      ...SPECIALITY_APP,
      remoteUrl: 'http://localhost:3004/SPECIALITYInspectionEntry.js'
    },
    {
      ...ONE_INSPECT_APP,
      remoteUrl: 'http://localhost:3005/SmartInspectEntry.js'
    },
    {
      ...ARB_APP,
      remoteUrl: 'http://localhost:3006/ARBInspectionEntry.js'
    },
    {
      ...MMC_APP,
      remoteUrl: 'http://localhost:3007/MMCInspectionEntry.js'
    },
    {
      ...TRUE_MEASURE_APP,
      remoteUrl: 'http://localhost:3008/CargoMeasurementEntry.js'
    }
  ],
  ite: [
    {
      ...CERT_APP,
      remoteUrl: 'https://cert-assist-ui-ite.awsmechinspectionsnp.manheim.com/CERTAssistEntry.js'
    },
    {
      ...TRA_APP,
      remoteUrl: 'https://tra-inspection.manheim.man-silo5.com/TRAInspectionEntry.js'
    },

    {
      ...PSI_APP,
      remoteUrl: 'https://psi-ui-ite.awsmechinspectionsnp.manheim.com/PSIInspectionEntry.js'
    },
    {
      ...SPECIALITY_APP,
      remoteUrl: 'https://speciality-inspection.manheim.man-silo5.com//SPECIALITYInspectionEntry.js'
    },
    {
      ...ONE_INSPECT_APP,
      remoteUrl: 'https://smartinspect.manheim.man-silo5.com/SmartInspectEntry.js'
    },
    {
      ...ARB_APP,
      remoteUrl: 'https://arb-ui-ite.awsmechinspectionsnp.manheim.com/ARBInspectionEntry.js'
    },
    {
      ...MMC_APP,
      remoteUrl: 'https://imaging-ui-int5.awsvivisionnp.manheim.com/MMCInspectionEntry.js'
    },
    {
      ...TRUE_MEASURE_APP,
      remoteUrl: 'https://cargo-measurement-ui.manheim.man-silo5.com/CargoMeasurementEntry.js'
    }
  ],
  uat: [
    {
      ...CERT_APP,
      remoteUrl: 'https://cert-assist-ui-uat.awsmechinspections.manheim.com/CERTAssistEntry.js'
    },
    {
      ...TRA_APP,
      remoteUrl: 'https://tra-inspection.manheim.man-uat.com/TRAInspectionEntry.js'
    },
    {
      ...PSI_APP,
      remoteUrl: 'https://psi-ui-uat.awsmechinspections.manheim.com/PSIInspectionEntry.js'
    },
    {
      ...SPECIALITY_APP,
      remoteUrl: 'https://speciality-inspection.manheim.man-uat.com//SPECIALITYInspectionEntry.js'
    },
    {
      ...ONE_INSPECT_APP,
      remoteUrl: 'https://smartinspect.manheim.man-uat.com/SmartInspectEntry.js'
    },
    {
      ...ARB_APP,
      remoteUrl: 'https://arb-ui-uat.awsmechinspections.manheim.com/ARBInspectionEntry.js'
    },
    {
      ...MMC_APP,
      remoteUrl: 'https://imaging-ui-uat.awsvivision.manheim.com/MMCInspectionEntry.js'
    },
    {
      ...TRUE_MEASURE_APP,
      remoteUrl: 'https://cargo-measurement-ui.manheim.man-uat.com/CargoMeasurementEntry.js'
    }
  ],
  prod: [
    {
      ...CERT_APP,
      remoteUrl: 'https://cert-assist-ui-prod.awsmechinspections.manheim.com/CERTAssistEntry.js'
    },
    {
      ...TRA_APP,
      remoteUrl: 'https://tra-inspection.manheim.com/TRAInspectionEntry.js'
    },
    {
      ...PSI_APP,
      remoteUrl: 'https://psi-ui-prod.awsmechinspections.manheim.com/PSIInspectionEntry.js'
    },
    {
      ...SPECIALITY_APP,
      remoteUrl: 'https://speciality-inspection.manheim.man.com//SPECIALITYInspectionEntry.js'
    },
    {
      ...ONE_INSPECT_APP,
      remoteUrl: 'https://smartinspect.manheim.com/SmartInspectEntry.js'
    },
    {
      ...ARB_APP,
      remoteUrl: 'https://arb-ui-prod.awsmechinspections.manheim.com/ARBInspectionEntry.js'
    },
    {
      ...MMC_APP,
      remoteUrl: 'https://imaging-ui.awsvivision.manheim.com/MMCInspectionEntry.js'
    },
    {
      ...TRUE_MEASURE_APP,
      remoteUrl: 'https://cargo-measurement-ui.manheim.com/CargoMeasurementEntry.js'
    }
  ]
};

export const supportedRemoteApps = (environment: Environment) => {
  return REMOTE_APPLICATIONS[environment];
};
